import { render, staticRenderFns } from "./GuardConfiguration.vue?vue&type=template&id=19608548&scoped=true"
import script from "./GuardConfiguration.vue?vue&type=script&lang=js"
export * from "./GuardConfiguration.vue?vue&type=script&lang=js"
import style0 from "./GuardConfiguration.vue?vue&type=style&index=0&id=19608548&prod&scoped=true&lang=css"
import style1 from "./GuardConfiguration.vue?vue&type=style&index=1&id=19608548&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19608548",
  null
  
)

export default component.exports